import { Button, Flex } from '@chakra-ui/react';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Drawer from 'components/Drawer';
import { RouteTabs, TabHeader, TabPanels } from 'components/Tabs';

import AccrualsBalances from './AccrualsBalances';
import Calendar from './Calendar';
import Requests from './Requests';
import RequestTimeOff from '../RightDrawer/RequestTimeOff';

const TIMEOFF_TAB_NAME = {
  requests: 'requests',
  pending: 'pending',
  calendar: 'calendar',
  accrualBalances: 'accrualBalances',
};

const TimeOffTabs: React.FC<unknown> = () => {
  const { t } = useTranslation(['timeOff', 'common']);

  const [tabHeaders] = useState([
    {
      label: t('timeOff:pendingRequests'),
      tabName: TIMEOFF_TAB_NAME.pending,
    },
    {
      label: t('common:request'),
      tabName: TIMEOFF_TAB_NAME.requests,
    },
    { label: 'Calendar', tabName: TIMEOFF_TAB_NAME.calendar },
    { label: 'Accruals and Balances', tabName: TIMEOFF_TAB_NAME.accrualBalances },
  ]);

  const tabPanels = useMemo(
    () => [
      { panel: <Requests requestType="pending" /> },
      { panel: <Requests /> },
      { panel: <Calendar /> },
      { panel: <AccrualsBalances /> },
    ],
    []
  );

  // useEffect(() => {
  //   if (data) {
  //     const updatedTabHeaders = [
  //       {
  //         label: t('common:request'),
  //         tabName: TIMEOFF_TAB_NAME.requests,
  //       },
  //       { label: 'Calendar', tabName: TIMEOFF_TAB_NAME.calendar },
  //       { label: 'Accrual And Balances', tabName: TIMEOFF_TAB_NAME.accrualBalances },
  //     ];
  //     setTabHeaders(updatedTabHeaders);
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [data, t]);

  return (
    <RouteTabs tabHeaders={tabHeaders}>
      <Flex justifyContent="space-between" flexDirection={{ base: 'column', md: 'row' }}>
        <TabHeader tabHeaders={tabHeaders} />
        <Drawer
          drawerTrigger={onOpen => (
            <Button colorScheme="secondary" mt={{ base: '5', md: '0' }} onClick={onOpen}>
              {t('timeOff:requestTimeOff')}
            </Button>
          )}
        >
          {onClose => <RequestTimeOff onClose={onClose} />}
        </Drawer>
      </Flex>
      <TabPanels tabPanels={tabPanels} />
    </RouteTabs>
  );
};
export default TimeOffTabs;
